import { List, Record } from "immutable";

import compactDisplays from "../../../../constants/compactDisplay";
import itemTypeCategories from "../../../../constants/itemTypeCategories";
import createFromJS from "../../../createFromJS";

export const InspectorTypeRecord = Record({
  id: "",
  label: "",
  references: List(),
  inverseReferences: List(),
  properties: List(),
  superTypes: List(),
  icon: "",
  color: "",
  defaultItemColor: "",
  canHaveDate: false,
  showInSequence: false,
  canIncludeInNarrative: false,
  showOnSidebar: false,
  showAsColumn: false,
  identifierPrefix: null,
  compactDisplay: compactDisplays.IDENTIFIER,
  category: itemTypeCategories.OTHER,
  canHaveLocationUri: false,
  // Pulled across from EventTypeRecord...
  // TODO: Still need to decide on best home for these...
  isRelative: false,
  relativeUnits: "seconds",
  labelDisplayLabel: null
});

const data = {
  objects: {
    superTypes: "List"
  },
  collections: {
    references: "InspectorReferenceRecord",
    properties: "PropertyRecord"
  }
};
createFromJS.registerCallback("InspectorTypeRecord", createFromJS.createNestedCallback(InspectorTypeRecord, data));
